var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore
import { useForm, Head } from '@inertiajs/react';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { useRoute } from 'ziggy-js';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard';
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input';
import JetLabel from '@/Jetstream/Label';
import JetValidationErrors from '@/Jetstream/ValidationErrors';
import { Ziggy } from "@/ziggy";
export default function TwoFactorChallenge() {
    var route = useRoute(Ziggy);
    var _a = useState(false), recovery = _a[0], setRecovery = _a[1];
    var form = useForm({
        code: '',
        recovery_code: '',
    });
    var recoveryCodeRef = useRef(null);
    var codeRef = useRef(null);
    function toggleRecovery(e) {
        e.preventDefault();
        setRecovery(true);
        setTimeout(function () {
            var _a, _b;
            if (recovery) {
                (_a = recoveryCodeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                form.setData('code', '');
            }
            else {
                (_b = codeRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                form.setData('recovery_code', '');
            }
        }, 100);
    }
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('two-factor.login'));
    }
    return (_jsxs(JetAuthenticationCard, { children: [_jsx(Head, { title: "Two-factor confirmation" }), _jsx("div", __assign({ className: "mb-4 text-sm text-gray-600" }, { children: recovery
                    ? 'Please confirm access to your account by entering one of your emergency recovery codes.'
                    : 'Please confirm access to your account by entering the authentication code provided by your authenticator application.' })), _jsx(JetValidationErrors, { className: "mb-4" }), _jsxs("form", __assign({ onSubmit: onSubmit }, { children: [recovery ? (_jsxs("div", { children: [_jsx(JetLabel, __assign({ htmlFor: "recovery_code" }, { children: "Recovery Code" })), _jsx(JetInput, { id: "recovery_code", type: "text", className: "mt-1 block w-full", value: form.data.recovery_code, onChange: function (e) {
                                    return form.setData('recovery_code', e.currentTarget.value);
                                }, ref: recoveryCodeRef, autoComplete: "one-time-code" })] })) : (_jsxs("div", { children: [_jsx(JetLabel, __assign({ htmlFor: "code" }, { children: "Code" })), _jsx(JetInput, { id: "code", type: "text", inputMode: "numeric", className: "mt-1 block w-full", value: form.data.code, onChange: function (e) { return form.setData('code', e.currentTarget.value); }, autoFocus: true, autoComplete: "one-time-code", ref: codeRef })] })), _jsxs("div", __assign({ className: "flex items-center justify-end mt-4" }, { children: [_jsx("button", __assign({ type: "button", className: "text-sm text-gray-600 hover:text-gray-900 underline cursor-pointer", onClick: toggleRecovery }, { children: recovery ? 'Use an authentication code' : 'Use a recovery code' })), _jsx(JetButton, __assign({ className: classNames('ml-4', { 'opacity-25': form.processing }), disabled: form.processing }, { children: "Log in" }))] }))] }))] }));
}
